<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
              <v-layout row wrap>
                 <v-flex d-flex xs12 style="margin-top: 20px">
                  <v-layout column>
                    <v-flex d-flex>
                      <v-card style="">
                        <v-card-text>
                          <h3 style="text-align: left;margin-bottom: 10px">Run Sheet Report</h3>
                          <v-btn flat class="primary" style="margin-left:900px;margin-bottom: 10px;margin-top:-40px" v-on:click="back()">Back</v-btn>
                          <v-divider divider: true></v-divider>
                          <v-layout row wrap>
                            <v-flex xs3 child-flex>
                              <v-layout row wrap>
                                <label style="margin-top:20px;margin-right: 10px">Show</label>
                                <v-overflow-btn
                                  :items="dropdown_list"
                                  label=""
                                  target="#dropdown-example"
                                ></v-overflow-btn>
                                <label style="margin-top:20px;margin-left: 10px">Entries</label>
                              </v-layout>
                            </v-flex>
                            <v-flex xs3 child-flex></v-flex>
                            <v-flex xs6 child-flex>
                              <v-layout row wrap>
                                <v-text-field
                                  label="Search"
                                ></v-text-field>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                                <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>list</v-icon></v-btn>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                          <v-data-table
                            :headers="headers"
                            :items="desserts"
                            class="elevation-1"
                            style="width:1200px"
                          >
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.no}}</td>
                              <td class="text-xs-left">{{ props.item.vehicleno}}</td>
                              <td class="text-xs-left">{{ props.item.servicelocation}}</td>
                              <td class="text-xs-left">{{ props.item.city}}</td>
                              <td class="text-xs-left">{{ props.item.arrivaldate}}</td>
                              <td class="text-xs-left">{{ props.item.arrivaltime}}</td>
                              <td class="text-xs-left">{{ props.item.tripno}}</td>
                              <td class="text-xs-left">{{ props.item.challanno}}</td>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Vehicle No', value: 'vehicleno' },
        { text: 'Service Location / Hub', value: 'servicelocation' },
        { text: 'City', value: 'city' },
        { text: 'Arrival Date', value: 'arrivaldate' },
        { text: 'Arrival Time', value: 'arrivaltime' },
        { text: 'Trip No', value: 'tripno' },
        { text: 'Challan No', value: 'challanno' }
      ],
      desserts: [
        {
          no: '1',
          vehicleno: 'MH-12-HJ-2015',
          servicelocation: 'Mumbai',
          city: 'Mumbai Suburban, Mumbai',
          arrivaldate: '06-May-2019',
          arrivaltime: '07:43:20',
          tripno: '001',
          challanno: 'CH001'
        }
      ]
    }
  },
  methods: {
    back () {
      this.$router.push('/Transportationtrip')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Transportationtripreport.vue